export enum ApiResourceDetailsTabs {
  Settings = 'settings',
  Permissions = 'permissions',
}

export enum ConnectorsTabs {
  Passwordless = 'passwordless',
  Social = 'social',
}

export enum WebhookDetailsTabs {
  Settings = 'settings',
}

export enum SignInExperiencePage {
  BrandingTab = 'branding',
  SignUpAndSignInTab = 'sign-up-and-sign-in',
  OthersTab = 'others',
}

export enum UserDetailsTabs {
  Settings = 'settings',
  Roles = 'roles',
  Logs = 'logs',
}

export enum RoleDetailsTabs {
  Settings = 'settings',
  Permissions = 'permissions',
  Users = 'users',
}
